export default __webpack_public_path__ + "static/media/heartFinger.644090c8.svg";